
import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService:AuthenticationService, private router:Router){

  }

  canActivate(){
    if(this.authService.loggedIn()){
      return true;
    }else{
      this.router.navigate(['/admin/login']);
      alert("Please login First");
      return false;
    }
  }
}


// this.authService.getProfile().subscribe((user) => {
//   ////console.log(user[0].isAdmin);
 
// this.router.navigate(['/admin/login']);
// alert("Please login First");
// },
// err=>{
// //////console.log(err);
// return false;
// });


// WEBPACK FOOTER //
// ./src/app/components/guards/auth.guard.ts